import React, { useState, useEffect } from 'react';
import { useRecoilState, useRecoilValue } from 'recoil';
import { Button, Checkbox, Col, Flex, Form, Input, Row, Tooltip } from 'antd';
import { appConfigAtomState } from '../../state/reducerAtoms/app.atom';


import './index.scss';
import { getAuthId } from '../../helpers/auth.helper';
import { translateThis } from '../../helpers/language.helper';
import { showSnackbar } from '../../components/snackbar/index';


import { myPortalState } from '../../state/reducerAtoms/myPortal.atom';
import { getProfile, updateProfile } from '../../services/api/auth';
import SVGIcons from '../../assets/images/icons/svgIcons';
import PageLayout from '../../features/app';



export default function MyProfile() {

    const appState = useRecoilValue(appConfigAtomState);
    const userId = getAuthId();
    const [isLoading, setIsLoading] = useState(true);
    const [data, setData] = useState({});
    // eslint-disable-next-line
    const [_, setMyPortalState] = useRecoilState(myPortalState)
    const [isEditEnabled, setIsEditEnabled] = useState(false);

    /**
  the legendary use effect function
  This will run very first on render
   */
    useEffect(() => {
        getData()
        return () => {
            setData({})
        };
        // eslint-disable-next-line
    }, []);

    // get users from api
    const getData = () => {
        setIsLoading(true);
        getProfile()
            .then((data) => setData(data.data))
            .catch(() => showSnackbar().failure(translateThis('Something went wrong')))
            .finally(() => setIsLoading(false));
    }

    /**
   * sets the form data 
   * @param {string} name the name of the field
   * @param {string} value  the value of the field
   */
    const setFormValue = (name, value) => {
        const formDataAs = { ...data };
        setData({ ...formDataAs, ...{ [name]: value } });
    }


    /**
   * updateData
   */
    const updateData = () => {
        if (userId) {
            const postData = {
                firstName: data.firstName,
                lastName: data.lastName,
                profilePic: data?.profilePic?.fileKey
            }
            updateProfile(postData)
                .then(() => showSnackbar().success(translateThis('Profile updated successfully')))
                .catch(() => showSnackbar().failure(translateThis('Something went wrong!.')))
                .finally(() => {
                    getData();
                })
        }

    }

    const onCancel = () => {
        setMyPortalState((prv) => ({ ...prv, ...{ selectedNavItem: 'parents', pageHeader: 'Parents' } }))

    }


    const onFinishFailed = (errorInfo) => {
        console.log('Failed:', errorInfo);
    };


    return (
        <>
            <PageLayout
                pageName={'profile'}
                pageTitle={'Profile'}
                bodyClassName={`provider-portal`}
                key={`${appState?.selectedLang}`}
            >

                <>{isLoading ? <span>loading...</span> :
                    <Flex className='profile-page-wrp add-edit-page-wrp' gap="middle" vertical>

                        <Form
                            name="profileView"
                            disabled={!isEditEnabled}
                            initialValues={data}
                            onFinish={updateData}
                            onFinishFailed={onFinishFailed}
                            layout="vertical"
                        >
                            <Row gutter={10}>

                                <Col span={8}>
                                    <Form.Item
                                        label="First Name"
                                        name="firstName"
                                        rules={[{ message: 'Please enter your First Name' }]}
                                        style={{ marginBottom: '12px' }}
                                    >
                                        <Input placeholder='First Name' />
                                    </Form.Item>
                                </Col>
                                <Col span={8}>
                                    <Form.Item
                                        label="Last Name"
                                        name="lastName"
                                        rules={[{ message: 'Please enter your Last Name' }]}
                                        style={{ marginBottom: '12px' }}
                                    >
                                        <Input placeholder='Last Name' />
                                    </Form.Item>
                                </Col>
                                <Col span={8}>
                                    <Form.Item
                                        label="E-mail"
                                        name="email"
                                        rules={[{ message: 'Please enter your E-mail' }]}
                                        style={{ marginBottom: '12px' }}
                                    >
                                        <Input
                                            suffix={data?.isEmailVerified ? null :
                                                <Tooltip title={"Email not verified"}>
                                                    <SVGIcons.AccidentIcon style={{ color: 'rgba(0,0,0,.45)' }} />
                                                </Tooltip>
                                            }

                                            placeholder='E-mail' />
                                    </Form.Item>
                                </Col>

                                <Col span={8}>
                                    <Form.Item
                                        label="Phone number"
                                        name="phoneNumber"
                                        rules={[{ message: 'Please enter your phone number' }]}
                                        style={{ marginBottom: '12px' }}
                                    >
                                        <Input placeholder='Phone number' />
                                    </Form.Item>
                                </Col>

                                <Col span={8}>
                                    <Form.Item
                                        label="Address"
                                        name="address"
                                        rules={[{ message: 'Please enter your Address' }]}
                                        style={{ marginBottom: '12px' }}
                                    >
                                        <Input placeholder='Address' />
                                    </Form.Item>
                                </Col>

                                <Col span={8}>
                                    <Form.Item
                                        label="State"
                                        name="state"
                                        rules={[{ message: 'Please enter your state' }]}
                                        style={{ marginBottom: '12px' }}
                                    >
                                        <Input placeholder='State' />
                                    </Form.Item>
                                </Col>
                                <Col span={8}>
                                    <Form.Item
                                        label="ZipCode"
                                        name="zipCode"
                                        rules={[{ message: 'Please enter ZipCode' }]}
                                        style={{ marginBottom: '12px' }}
                                    >
                                        <Input placeholder='ZipCode' />
                                    </Form.Item>
                                </Col>
                                <Col span={8}>
                                    <Row gutter={5}>
                                        <Col span={24}>
                                            <Form.Item label="Stripe-Onboarding" name='hasCompletedStripeOnboarding' valuePropName="checked">
                                                <Checkbox>has Completed Stripe-Onboarding</Checkbox>
                                            </Form.Item>
                                        </Col>
                                    </Row>
                                </Col>
                                <Col span={24}>
                                    <Form.Item
                                        label="Status"
                                        name="status"
                                        rules={[{ message: 'Please enter ZipCode' }]}
                                        style={{ marginBottom: '12px' }}
                                    >
                                        {data?.status === 'active' ? <span className='resolved'> Active </span> : <span className='pending'> Pending </span>}
                                    </Form.Item>

                                </Col>

                            </Row>
                            <br />
                            <br />
                            <br />
                            <br />
                            <Flex gap={15} justify='space-between' align='center' horizontal="true" className='button-sec'>
                                <Button onClick={onCancel} className='cancel-btn' type='default' htmlType="reset"> cancel </Button>
                                <Button onClick={updateData} className='fill-btn' type="primary" htmlType="submit"> save changes </Button>
                            </Flex>

                        </Form>


                    </Flex >
                }


                </>













            </PageLayout >
        </>
    );
}